<template>
    <label :for="forTarget" :class="display">
        <slot></slot>
        <span v-if="required">*</span>
        <small v-if="subtext">{{ subtext }}</small>
    </label>
</template>

<script>
    import { THEMES, SIZES } from '@/data/themes'

    export default {
        name: "OSJLabel",
        props : {
            subtext   : String,
            forTarget : String,
            required  : Boolean,
            limit     : Number,
            theme     : String,
            size      : String
        },
        computed : {
            display () {
                return [
                    THEMES[this.theme] || THEMES.light,
                    SIZES[this.size] || SIZES.small
                ]
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/vars";
    
    span{
        color: $red;
    }
    
    label{
        display: block;
        margin-bottom: 0.5rem;
        font-weight: 700;
        color: white;       
    }

    small{
        font-style: italic;
        color: $mid-gray;
    }

    .theme{
        &-dark{
            color: $gray;
        }
        &-light{
            color: white;
        }
    }

    .size{
        &-small{
            font-size: 1.4rem;
        }
        &-large{
            font-size: 1.8rem;
        }
    }
</style>